import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SmartContractOperationService } from "../smart-contract-operation.service";
import { FabricChaincode } from "@aptsi-types";
import { Subject } from "rxjs";
import { KeycloakStateService } from "src/app/core/service/utility.service";

@Component({
  selector: 'app-smart-contract-operation-search',
  templateUrl: './smart-contract-operation-search.component.html',
  styleUrls: ['./smart-contract-operation-search.component.scss']
})
export class SmartContractOperationSearchComponent implements OnInit {

  contracts: FabricChaincode[] = [];
  filteredData: FabricChaincode[] = [];
  searchedData: FabricChaincode[] = [];


  // ─── Pagination ───────────────────────────────────────────────
  currentPage = 1;
  itemsPerPage = 7;
  totalPages = 1;

  // ─── Search ──────────────────────────────────────────────────
  searchText: string = "";
  filterByHeader: string = "all";
  searchTextChanged = new Subject<string>();
  filterByStatus: string = '';

   organizationId: string | null = '';

  issearch: boolean = false;
  loading: boolean = false;

  headers = [
    { name: 'ID', property: 'chaincodeId', showInDropdown: true },
    { name: 'Smart Contract Name', property: 'chaincodeName', showInDropdown: true },
    { name: 'Channel', property: 'channelName', showInDropdown: true },
    { name: 'Status', property: 'status', showInDropdown: true }
  ];


  buttonConfig = {
    submit: true
  };

  constructor(
    private service: SmartContractOperationService,
    private router: Router,
    private route: ActivatedRoute,
    private keycloakStateService: KeycloakStateService
  ) { }

  ngOnInit(): void {
    this.organizationId = this.keycloakStateService.getOrganizationId();
    this.fetch();
  }

  fetch(): void {
    this.service.getContracts(this.organizationId).subscribe((res: any[]) => {
      this.contracts = res;
      console.log("Contracts fetched:", this.contracts);
      this.filteredData = this.contracts;
    });
  }


  back(): void {
    this.router.navigate(["secure-blockchain/auth-tools"]);
  }

  changePage(page: number): void {
    this.currentPage = page;
  }

  onSearchTextChange(): void {

    if (!this.searchText) {
      this.issearch = false;
      return;
    }

    this.issearch = true;

    this.service.searchContracts(this.currentPage-1, this.searchText, this.filterByStatus, this.organizationId )
      .subscribe((res: any[]) => {
        this.searchedData = res;
      });
  }

  handleAction(event: any): void {
    const row = event.rowData;

    if (event.action === "submit") {
      this.router.navigate(['../submit', row.chaincodeId], {
        relativeTo: this.route
      });
    }
  }
}